import {FC, useState} from 'react'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {IndemnityArea} from '../../core/_models'
import {ModalEditeIdemminityArea} from '../../../formIndemnityItemsEdite/ModalEditeIdemminityArea'

type Props = {
  IndemnityArea: IndemnityArea
}
const IndemnityAreaActionsCell: FC<Props> = ({IndemnityArea}) => {
  const [showIndenityAreaModal, setIndenityAreaModal] = useState<boolean>(false)
  return (
    <>
      <div className='d-flex flex-column align-items-md-center'>
        <button
          onClick={() => {
            setIndenityAreaModal(true)
          }}
          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
        >
          <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
        </button>
        <ModalEditeIdemminityArea
          id='idemminityArea'
          show={showIndenityAreaModal}
          handleClose={() => setIndenityAreaModal(false)}
          area={IndemnityArea}
        />
      </div>
    </>
  )
}

export {IndemnityAreaActionsCell}
